import { createSelector } from '@ngrx/store';
import { AppState } from '../../core/store/core.state';

export const digitalProductState = (state: AppState) => state.digitalProduct;

export const getDigitalProductsSelector = createSelector(
    digitalProductState,
    (state) => state.digitalProductList
);

export const getCurrentDigitalProductSelector = createSelector(
    digitalProductState,
    (state) => state.currentDigitalProduct
);
